import React, { useMemo } from 'react';

import { Typography } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { useGridApiRef } from '@mui/x-data-grid-pro';

import { Province } from '../../../@types/KingdomResponse';
import { ArmyLite } from '../../../@types/State';
import { useIntelState } from '../../../context/IntelState';
import { armyGridColDefinitions } from '../columnDefinitions/armiesColumnDefinitions';
import GridViewToolBar from '../components/GridViewToolBar';
import { StripedDataGrid } from '../components/StripedDataGrid';
import { getArmiesData } from '../helpers/intelGridHelpers';

const cellCss = {
  paddingLeft: '5px',
  paddingRight: '5px',
};

const resizeOptions = {
  includeOutliers: true,
  includeHeaders: true,
};

interface Props {
  dataSet: Province[] | undefined;
}

const GridView: React.FC<Props> = ({ dataSet }) => {
  const { intelState } = useIntelState();
  const apiRef = useGridApiRef();
  const armyRows: ArmyLite[] | null = useMemo(() => {
    const races =
      intelState.server === 1 ? intelState.racesWol : intelState.racesGen;
    return getArmiesData(dataSet, races);
  }, [dataSet, intelState]);

  return armyRows ? (
    <div
      style={{
        height: '100%',
        maxWidth: '100%',
      }}
    >
      <StripedDataGrid
        autoHeight
        rows={armyRows}
        apiRef={apiRef}
        autosizeOptions={resizeOptions}
        autosizeOnMount={false}
        columns={armyGridColDefinitions}
        density='compact'
        slots={{
          toolbar: GridViewToolBar,
          loadingOverlay: LinearProgress,
          columnUnsortedIcon: null,
        }}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={intelState.loading}
        hideFooterPagination
        hideFooter
        disableColumnMenu
        sx={{
          '& .MuiDataGrid-columnHeader': cellCss,
          '& .MuiDataGrid-cell': cellCss,
        }}
      />
    </div>
  ) : (
    <Typography variant='body1' sx={{ marginTop: 3 }}>
      No Kingdom Data found
    </Typography>
  );
};

export default GridView;
